import {useLenis} from 'lenis/react';
import { useRef } from "react";
import { useApp } from '@/context/AppContext';
import Cta from "../cta/cta";

export default function StoryFormOverlay ({setIsOpen, onAgree}) {
  const lenis = useLenis();
  const overlayRef = useRef(null)
  const {windowSize} = useApp()

  const onClose = () => {
    setIsOpen(false)
  }

  //   useEffect(() => {
  //     if (overlayRef.current) {
  //       overlayRef.current.style.top = window.scrollY + 'px'
  //     }
  //     if (lenis) {
  //       lenis.stop()
  //     } 
  //     return () => {
  //       lenis.start()
  //     }
  //   }, [lenis, overlayRef])

  //   useEffect(() => {
  //     if (overlayRef.current) {
  //       overlayRef.current.style.top = window.scrollY + 'px'
  //     }
  //   }, [windowSize, overlayRef])

  return (
    <div className="fixed z-100 top-0 left-0 w-screen full-height-screen  bg-main-dark flex items-center justify-center max-md:px-4 max-md:py-10" ref={overlayRef} data-lenis-prevent>
      {/* <Cta 
        aria-label="Close"
        className='absolute z-50 top-[calc(2.5rem)] right-6 cta-light cta-icon-stroke-theme cta-circle-small pointer-events-auto md:top-[calc(var(--space-8))] md:right-(--space-8) md:cta-circle'
        onClick={onClose}>
        <Close aria-hidden="true"/>
      </Cta> */}
      <div className='lw-full md:w-160 h-full md:h-[84%] md:max-h-190 bg-white rounded-2xl pt-8 flex flex-col'>
        <h2 className='heading-4-small px-8 mb-8'>Testimonial Submission Agreement</h2>
        <div className='h-[76%] overflow-y-auto p-8 border-t-1 border-b-1 border-black/5'>
          <p className='body-2-sans mb-6'>Thank you for your interest in Ancestry. We always appreciate your enthusiasm and excitement for family history research and our products. We hope that your stories can help other members benefit from all that Ancestry has to offer. In order to submit your testimonial about Ancestry, you must agree to the legal terms below:</p>
          <p className='body-2-sans mb-6'>I represent and warrant that I am at least 18 years of age and I have all authority necessary to agree to and grant the permissions given in this Agreement. I understand that by submitting my testimonial stories, images, videos, quotes and/or other information through this website (the "Submission"), I grant Ancestry.com Operations Inc. and its affiliated companies (collectively,
"Ancestry") a perpetual license to use, distribute, edit or republish my Submissions, in whole or in part, including without limitation my name, likeness, and voice, for advertising, promotion, and any other purpose desired by Ancestry and in all or any media now known or developed in the future, including the Internet, and anywhere throughout the world, without limitation as to duration or frequency of usage, and with or without attribution to me, at Ancestry's sole discretion. I acknowledge that Ancestry is under no obligation to use my Submission and may decide, at its sole discretion, not to use the Submission. I waive any inspection and/or approval of the use of the Submissions and hereby release Ancestry, its agents and assigns, from any obligation to make payment hereunder and from any liability incurred in connection with the use of the Submission. I agree to hold Ancestry, its agents and assigns, who use the Submission harmless against any claims, losses, damages or liability arising from such use. I also agree that Ancestry may store and use my contact information that I am providing to contact me about my Submission.</p>
          <p className='body-2-sans mb-6'>I represent and warrant that any statements made by me in the Submission are true, accurately reflect my opinion of and experience with Ancestry's products and services, and are not misleading. The Submission is my own work and I have all necessary consents from any third parties that are included in or referenced to in the Submission. Upon request, I will promptly provide written support for (i) any claims made in the Submission that are or appear to be factual, and (ii) any necessary third party consents.</p>
        </div>
        <div className='flex flex-1 justify-end items-center px-8 gap-3'>
          <Cta onClick={onClose} className='cta-secondary' aria-label="Cancel">Cancel</Cta>
          <Cta onClick={onAgree} className='cta' aria-label="Cancel">Agree</Cta>
        </div>
      </div>
    </div>
  )
}